import { getIsOnSale } from '@wix/da-shared-react/pkg/utils/adoptables';
import { InitAdapter } from '../../types';

export const initAdapter: InitAdapter = ({ deviation }): boolean =>
  !!(deviation && getIsOnSale(deviation));
